import React from 'react';
import classNames from 'classnames';
import { ResponsiveImage } from '../../components';
import { Link } from '../PageBuilder/Primitives/Link';
import Carousel from '../../components/Carousel';
import { getColumnCSS, getResponsiveImageSizes } from '../../components/Carousel/CarouselColumnHelper';

/**
 * Simple Collection Button Component - renders collection as a button with small image and text
 */
const CollectionButton = ({ block, responsiveImageSizes, className }) => {
  // Extract required fields from block data
  const href = block?.callToAction?.href;
  const image = block?.media?.image;
  const alt = block?.media?.alt || block?.title?.content || 'Collection image';
  const title = block?.title?.content;

  // Don't render if missing critical data
  if (!title) {
    return null;
  }

  // Get available image variants for ResponsiveImage
  const imageVariants = image?.attributes?.variants || {};
  const variantNames = Object.keys(imageVariants).filter(name => name.startsWith('original'));

  const buttonContent = (
    <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all duration-200 group">
      
      {/* Small Image on Left */}
      {image && (
        <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
          <ResponsiveImage
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-200"
            image={image}
            alt={alt}
            variants={variantNames.length > 0 ? variantNames : ['square400']}
            sizes="64px"
          />
        </div>
      )}

      {/* Title on Right */}
      <div className="flex-1 min-w-0">
        <h3 className="text-lg font-semibold text-gray-900 font-['Be_Vietnam_Pro'] truncate group-hover:text-gray-700 transition-colors">
          {title}
        </h3>
      </div>
    </div>
  );

  return (
    <Link href={href} className={classNames("block", className)}>
      {buttonContent}
    </Link>
  );
};

/**
 * Custom Judaica Collections Carousel Component
 * Simple button-style layout with small images and text
 */
const JudaicaCollectionsCarousel = props => {
  const {
    sectionId,
    className,
    rootClassName,
    numColumns = 2, // Default to 2 columns for better button layout
    blocks = [],
    options,
  } = props;

  const numberOfBlocks = blocks?.length;
  const hasBlocks = numberOfBlocks > 0;

  return (
    <div
      id={sectionId}
      className={classNames(className, rootClassName)}
    >
      {hasBlocks ? (
        <Carousel
          id={sectionId}
          numColumns={numColumns}
          className={getColumnCSS(numColumns)}
        >
          {blocks.map((block, index) => (
            <CollectionButton
              key={`${sectionId}-${index}`}
              block={block}
              responsiveImageSizes={getResponsiveImageSizes(numColumns)}
            />
          ))}
        </Carousel>
      ) : null}
    </div>
  );
};

export default JudaicaCollectionsCarousel; 